import { useState } from "react";
export default function useAudioSink() {
  const [activeSinkId, setActiveSinkId] = useState("default");
  return { activeSinkId, setActiveSinkId };
}
